import { useQuery } from '@tanstack/react-query';
import { authKeys, fetchMe } from '../../api/auth';

/**
 * The session bootstrap query (ARCHITECTURE_PLAN §10 route guards). Single
 * definition shared by every guard/page so the cache entry is one consistent
 * object. `retry: false`: a failed bootstrap renders its error + requestId
 * immediately instead of stalling the guard behind retries.
 *
 * `user === null` means "logged out" (NOT an error); the guard redirects.
 */
export function useMe() {
  return useQuery({
    queryKey: authKeys.me,
    queryFn: ({ signal }) => fetchMe(signal),
    staleTime: 60_000,
    retry: false,
  });
}
